import facebook from './image/facebook.png';
import facebookBlue from './image/facebookblue.png';
import instagram from './image/instagram.png';
import instagramblue from './image/instagramblue.png';
import linkedin from './image/linkedin.png';
import linkedinblue from './image/linkedinblue.png';
import whatsapp from './image/whatsapp.png';
import whatsappblue from './image/whatsappblue.png';
import youtube from './image/youtube.png';
import youtubeblue from './image/youtubeblue.png';
import chat from './image/chat.png';
import chatblue from './image/chatblue.png';
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';

export const navBarLinks = [{
  link: "HOME",
  subLinks: [
    "Look up NPOs",
    "Discover NPOs across India",
    "Give with confidence to NPOs",
    "Offers/ Asks/ Events/ Announcements",
    "Get involved with NPOs",
    "Power your philanthropy",
    "Meet our recently certified NPOs",
    "Featured NPOs/ Causes/ Campaigns",
    "Learn about the NPO sector in India",
    "Understand needs and issues from the ground",
    "Meet the changemakers",
    "Know how institutions & individuals use GuideStar India",
    "Our Strategic Partners and Collaborators"
  ],


},
{
  link: 'DISCOVER/ SUPPORT NPOs',
  to: '/search'
},
{
  link: 'CERTIFIED NPOs LIST',

},
{
  link: 'UPDATE YOUR NPO PROFILE',

},
{
  link: 'HELP',

},
{
  link: 'MEDIA',

},
]


export const hoverImages = [


  {
    defaultSrc: youtube,
    hoverSrc: youtubeblue,
    alt: "YouTube",
    link: "https://www.youtube.com/@CSISIndia"
  },
  {
    defaultSrc: chat,
    hoverSrc: chatblue,
    alt: "chat",
    link: "https://forum.guidestarindia.org/"
  },
  {
    defaultSrc: whatsapp,
    hoverSrc: whatsappblue,
    alt: "WhatsApp",
    link: "https://wa.me/918356832329"
  },
  {
    defaultSrc: facebook,
    hoverSrc: facebookBlue,
    alt: "Facebook",
    link: "https://www.facebook.com/guidestarindia"
  },
  {
    defaultSrc: instagram,
    hoverSrc: instagramblue,
    alt: "Instagram",
    link: "https://www.instagram.com/guidestarindia/"
  },
  {
    defaultSrc: linkedin,
    hoverSrc: linkedinblue,
    alt: "linkedin",
    link: "https://www.linkedin.com/company/guidestar-india/"
  },

];

const email = localStorage.getItem("email")
const dataUserAccessToken = localStorage.getItem("dataUserAccessToken")

export const navLinks = [
  {
    type: 'link',
    to: '/',
    text: 'Home',
    subLinks: [
      // { text: 'Look up NPOs', to: '/' },
      { text: 'Discover NPOs across India', to: 'discover_sec' },
      { text: 'Give with confidence to Certified NPOs', to: 'seal_sec' },
      { text: 'Offers/ Asks/ Events/ Announcements', to: 'opportunities' },
      { text: 'Get involved with NPOs', to: 'repositories_sec' },
      { text: 'Power your philanthropy and impact', to: 'philanthropy_sec' },
      { text: 'Meet our recently certified NPOs', to: 'certified_sec' },
      { text: 'Featured NPO/ Cause/ Campaign', to: 'featured_npo' },
      { text: 'Learn about the NPO sector in India', to: 'sectors_sec' },
      { text: 'Understand needs and issues from the ground', to: 'issue_sec' },
      { text: 'Meet the Changemakers', to: 'change_makers_sec' },
      { text: 'Know how institutions & individuals use GuideStar India', to: 'user_info_sec' },
      { text: 'Our Strategic Supporters and Collaborators', to: 'collaborators_sec' }
    ],
  },
  {
    type: 'anchor',
    to: 'discover_sec',
    text: 'Discover/ Support Credible NPOs',
  },
  {
    type: 'anchor',
    to: 'seal_sec',
    text: 'Certified NPOs List'
  },
  {
    type: 'link',
    to: '/npo-login',
    text: 'Update your NPO Profile',
  },
  {
    type: 'text',
    to: '',
    text: 'About Us'
  },
  {
    type: 'link',
    to: '/',
    text: 'Help/ FAQs'
  },
  {
    type: 'link',
    to: '/',
    text: 'Media'
  },
  {
    type: 'link',
    to: '/contact',
    text: 'Contact Us'
  },


  { type: 'button', to: (email && dataUserAccessToken) ? '/profile' : '/loginDataUser', text: (email && dataUserAccessToken) ? <>Profile Page <PermIdentityOutlinedIcon /></> : 'Sign In / Create Account' }
];